import axios from 'axios';
import * as authDuck from '../store/ducks/auth.duck';
import store from '../store/store';
import { HttpService } from './HttpService';

export class MutantApiService extends HttpService {
	constructor() {
		const instance = axios.create({
			baseURL: `${process.env.REACT_APP_API_HOST}/api`,
			headers: {
				'Content-type': 'application/json',
			},
			maxContentLength: Infinity,
			maxBodyLength: Infinity
		});

		super(instance);
	}

	async makeHttpRequest(config) {
		const authData = this.getAuthData();
		if (authData?.accessToken) {
			config.headers = {
				...(config.headers || {}),
				Authorization: `Bearer ${authData.accessToken}`,
			};
		}
		return super.makeHttpRequest(config);
	}

	getAuthUser() {
		const {
			auth: { user },
		} = store.getState();
		return user;
	}


	async handleRequestError(e, config) {
		console.log(`Error ${e} on ${config.url}`);
		if (e.response.status !== 401) {
			return super.handleRequestError(e, config);
		}

		const authData = this.getAuthData();

		if (authData && authData.refreshToken) {
			const response = await super.makeHttpRequest({
				...config,
				url: 'auth/refresh',
				method: "GET",
				headers: {
					Authorization: `Bearer ${authData.refreshToken}`
				}
			});

			if (response) {
				store.dispatch(authDuck.actions.refresh({
					...authData,
					accessToken: response.accessToken,
					refreshToken: response.refreshToken
				}));

				return this.makeHttpRequest(config);
			}
		}
	}

}
